import { money } from './money'

/**
 * Imprime un recibo/ticket de la venta en una ventana aparte (window.print).
 * Se arma en el contexto de la ventana ACTUAL (donde `money`/currencyFormat
 * existen) y se vuelca ya formateado. Fail-soft: si el navegador bloquea el
 * popup, no rompe nada.
 */
const esc = (value) =>
  String(value == null ? '' : value).replace(/[<>&]/g, (c) => ({ '<': '&lt;', '>': '&gt;', '&': '&amp;' }[c]))

const brand = () => {
  const meta = typeof document !== 'undefined' ? document.querySelector('meta[name="app_name"]') : null
  return (meta && meta.content) || 'Dolce Vita'
}

export const printReceipt = (sale) => {
  if (!sale) return

  const r = sale._receipt || {}
  const inv = sale.invoice || {}
  const t = sale.totals || {}
  const pay = sale.payment || {}

  const rows = []
  ;(r.lines_services || []).forEach((s) => {
    rows.push(`<tr><td>${esc(s.name)}</td><td class="r">${money(s.price)}</td></tr>`)
  })
  ;(r.lines_products || []).forEach((p) => {
    rows.push(`<tr><td>${esc(p.name)} x${esc(p.qty)}</td><td class="r">${money((Number(p.unit_price) || 0) * (Number(p.qty) || 0))}</td></tr>`)
  })

  const line = (label, value, strong) =>
    `<tr class="${strong ? 'tot' : ''}"><td>${esc(label)}</td><td class="r">${value}</td></tr>`

  const html = `<!doctype html><html><head><meta charset="utf-8"><title>${esc(brand())} - Recibo</title>
<style>
  * { font-family: monospace; }
  body { width: 300px; margin: 0 auto; padding: 10px; color: #000; }
  h1 { font-size: 15px; text-align: center; margin: 0 0 2px; }
  .sub { text-align: center; font-size: 11px; margin-bottom: 8px; }
  table { width: 100%; border-collapse: collapse; font-size: 12px; }
  td { padding: 1px 0; }
  .r { text-align: right; }
  .sep td { border-top: 1px dashed #000; padding-top: 4px; }
  .tot td { font-weight: bold; font-size: 13px; }
  .ft { text-align: center; font-size: 10px; margin-top: 10px; }
</style></head><body>
  <h1>${esc(brand())}</h1>
  <div class="sub">
    ${inv.numero_comprobante ? 'Factura ' + esc(inv.numero_comprobante) + '<br>' : ''}
    ${sale.booking && sale.booking.id ? 'Venta #' + esc(sale.booking.id) + '<br>' : ''}
    ${r.customer_name ? esc(r.customer_name) : ''}
  </div>
  <table>
    ${rows.join('')}
    <tr class="sep"><td>Subtotal</td><td class="r">${money(t.subtotal)}</td></tr>
    ${Number(t.manual_discount) > 0 ? line('Descuento', '-' + money(t.manual_discount)) : ''}
    ${line('IVA', money(t.tax))}
    ${Number(t.tip) > 0 ? line('Propina', money(t.tip)) : ''}
    ${line('TOTAL', money(t.total), true)}
    ${line('Cobrado (' + esc(pay.method || '') + ')', money(t.amount_due))}
  </table>
  <div class="ft">Gracias por su compra</div>
</body></html>`

  const win = window.open('', '_blank', 'width=360,height=640')
  if (!win) return

  win.document.write(html)
  win.document.close()
  win.focus()
  setTimeout(() => {
    win.print()
  }, 150)
}
